<template>
    <header class="header">
        <div class="header__upper">
            <div class="header__wrapper">
                <div class="header__left">
                    <router-link to="/"><img src="@/assets/images/header/logo.png" alt="" class="header__logo">
                    </router-link>
                </div>
                <div class="header__right">
                    <nav class="header__top-nav">
                        <router-link v-for="link in navTop" :key="link.link" :to="link.link" :class="`header__top-link ${link.class || ''}`">
                            <img :src="require(`@/assets/svg/${link.icon}.svg`)" alt="" class="header__icon">
                            <span v-if="link.link === '/zgloszenia' && userData.unread_count > 0" class="header__badge">
                                {{ userData.unread_count }}
                            </span>
                            {{ link.desc }}
                        </router-link>
                    </nav>
                </div>
            </div>
            <div class="header__wrapper header__wrapper--end">
                <nav class="header__main-nav">
                    <router-link v-for="link in filteredNavigation(userData)" :to="link.link" :key="link.link" class="header__link">
                        {{ link.desc }}
                    </router-link>
                </nav>
            </div>
        </div>
        <div class="header__lower">
            <img src="@/assets/images/header/major.png" alt="" class="header__major">
        </div>
    </header>
</template>

<script>
import { mapGetters } from "vuex"

export default {
    name: "Header",
    computed: mapGetters({
        navTop: 'navTop',
        navMain: 'navMain',
        isAuth: 'isAuthenticated',
        headers: 'getSecuredRequestHeader',
        userData: "getUserData",
    }),
    methods: {
        filteredNavigation(userData) {
            return this.navMain.filter(link =>
                (userData.is_doctor && link.onlyForDoctors)
                || !link.onlyForDoctors
                || userData.is_admin
            );
        },
    },
};
</script>

<style lang="scss">
.header {
    $this: &;

    &__wrapper,
    &__lower {
        width: 95%;
        max-width: 1140px;
        margin: auto;
    }

    &__upper {
        background: #F1F1F1;

        #{$this}__wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;

            &--end {
                justify-content: flex-end;
            }
        }

        #{$this}__top {
            &-nav {
                display: flex;
                align-items: center
            }

            &-link {
                position: relative;
                color: #505050;
                font-size: 18px;
                display: flex;
                align-items: center;
                margin: 0 20px;

                &.router-link-active {
                    font-weight: 600;
                }

                #{$this}__icon {
                    display: block;
                    margin: 0 10px 0 0;
                    height: 20px;
                    width: 25px;
                    object-fit: scale-down;
                    object-position: right;
                }

                #{$this}__badge {
                    padding: 1px 5px;
                    font-size: 12px;
                    background: #94c120;
                    color: #ffffff;
                    border-radius: 10px;
                    font-weight: bold;
                    min-width: 20px;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 5px 5px -5px -20px;
                    display: inline-block;

                }
            }
        }

        #{$this}__main-nav {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            background: #36BACA;
            min-height: 90px;
            padding: 0 50px;
            border-radius: 0 50px;
            position: relative;

            #{$this}__link {
                font-size: 18px;
                color: #fff;
                font-weight: 600;
                text-transform: uppercase;
                max-width: 170px;
                text-align: center;
                margin: 0 20px;
                min-height: 90px;
                display: inline-flex;
                align-items: center;

                &.router-link-exact-active {
                    box-shadow: 0 -10px 0 0 #158491 inset;
                }
            }
        }
    }

    &__lower {
        margin-top: -90px;

        #{$this}__major {
            width: 945px;
            max-width: 100%;
        }
    }
}

.opacity-50 {
    opacity: 0.5;
}
</style>
